import Keycloak, { KeycloakConfig, KeycloakInitOptions } from "keycloak-js";

let keycloakInstance: Keycloak | null = null;

export const getKeycloak = (): Keycloak => {
  if (keycloakInstance) return keycloakInstance;

  const config = window.CONFIG;
  if (!config?.REACT_APP_KEYCLOAK_SERVER_URL || !config.REACT_APP_KEYCLOAK_REDIRECT_URL) {
    throw new Error("Configuração do Keycloak não disponível no window.CONFIG");
  }

  keycloakInstance = new Keycloak({
    url: config.REACT_APP_KEYCLOAK_SERVER_URL,
    realm: "hub-digital",
    clientId: "portal-empresarial",
  });

  return keycloakInstance;
};

export const getKeycloakInitOptions = (): KeycloakInitOptions => {
  return {
    onLoad: "check-sso",
    redirectUri: window.CONFIG.REACT_APP_KEYCLOAK_REDIRECT_URL,
    checkLoginIframe: false,
  };
};
